<template>
  <div class="item-listing-group">
    <div v-if="debugging">
      Total: {{ itemCount.total }}<br>
      Current: {{ itemCount.current }}<br>
      Per Page: {{ itemCount.perPage }}<br>
      Page: {{ itemCount.page }}<br>
      Next: {{ itemCount.next }}<br><br>
      Count: {{ count }}
    </div>
    <h2>
      Featured Select Brew<sup>&reg;</sup> Equipment
    </h2>
    <div
      class="item-listing-group__content"
    >
      <template
        v-for="(item, index) in filteredItems"
      >
        <transition
          :key="index"
          name="equipment-more"
        >
          <Equipment
            v-show="!item.isExcluded && index < itemsSoFar"
            :equipment="item"
          />
        </transition>
        <div
          v-if="debugging"
          :key="index"
        >
          {{ index }}
        </div>
        <!-- counter: {{ liveCounter }} -->
      </template>
    </div>
    <div class="view-more-container">
      <button
        v-if="itemCount.current > itemsSoFar"
        class="button"
        @click="addMoreItems"
      >
        View {{ itemCount.next }} More of {{ itemsLeft }} Equipment }}
      </button>
    </div>
  </div>
</template>


<script>
  import Equipment from "./items/Equipment.vue"

  import store from "../store"

  export default {
    name: "EquipmentView",
    components: {
      Equipment
    },
    data: () => {
      return {
        itemCount: {
          current: 8,
          total: 0,
          perPage: 8,
          page: 1,
          next: 0
        },
        liveCounter: 0,
        debugging: false
      }
    },
    computed: {
      count: function() {
        return store.state.items.filter(i => {
          return !i.isExcluded;
        }).length;
      },
      filteredItems: function() {
        //console.log(this.$store.state.items);
        // this.trendCount.total = this.count;
        // this.trendCount.current = this.count < this.trendCount.current ? this.count : this.trendCount.current;
        return this.$store.state.items.filter(function(item) {
          return !item.isExcluded;
        });
      },
      itemsLeft: function() {
        return this.itemCount.current - (this.itemCount.perPage * this.itemCount.page)
      },
      itemsSoFar: function() {
        return this.itemCount.perPage * this.itemCount.page
      }
    },
    updated() {
      this.itemCount.current = this.count
      this.itemCount.next = (this.itemCount.current >= this.itemCount.perPage * (this.itemCount.page + 1)) ? this.itemCount.perPage : this.itemCount.current - (this.itemCount.perPage * this.itemCount.page)
    },
    created() {
      this.itemCount.total = this.count
      this.itemCount.current = this.count
      this.itemCount.next = (this.itemCount.current >= this.itemCount.perPage * (this.itemCount.page + 1)) ? this.itemCount.perPage : this.itemCount.current - (this.itemCount.perPage * this.itemCount.page)
    },
    methods: {
      addMoreitems: function() {
        ++this.itemCount.page
        // this.trendCount.current = this.trendCount.current + this.trendCount.perPage
      },
      incrementCounter: function(trend) {
        if (!trend.isExcluded) {
          this.liveCounter++
        }
        // console.log('liveCounter', this.liveCounter)
      }
    }
  };
</script>
